<template>
  <div class="app-container">
    <div class="data-view-wrap">
      <div class="item-wrap" v-for="(item, index) in inventoryItems" :key="index">
        <div>{{ item.label }}</div>
        <div class="unit">
          <span>{{ item.value }}</span>
          <span>{{ item.unit }}</span>
        </div>
      </div>
    </div>
    <el-form :model="searchData" :inline="true" label-width="140px" label-position="right" ref="searchData">
      <el-form-item label="仓库编号" prop="stationId">
        <el-input v-model="searchData.stationId" placeholder="请输入" style="width: 100%;" clearable></el-input>
      </el-form-item>
      <el-form-item label="仓库名称" prop="stationName">
        <el-input v-model="searchData.stationName" placeholder="请输入" style="width: 100%;" clearable></el-input>
      </el-form-item>
      <el-form-item label="省" prop="provinceId">
        <el-select v-model="searchData.provinceId" placeholder="请选择" clearable style="width: 100%" @change="provinceChangeFun">
          <el-option v-for="item in provinceListNew" :key="item.provinceId" :label="item.province" :value="item.provinceId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="市" prop="cityId">
        <el-select v-model="searchData.cityId" placeholder="请选择" clearable style="width: 100%" @change="cityChangeFun" :disabled="!searchData.provinceId">
          <el-option v-for="item in cityListNew" :key="item.cityId" :label="item.city" :value="item.cityId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区" prop="countyId">
        <el-select v-model="searchData.countyId" placeholder="请选择" clearable style="width: 100%" :disabled="!searchData.cityId">
          <el-option v-for="item in districtListNew" :key="item.countyId" :label="item.county" :value="item.countyId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人" prop="contactName">
        <el-input v-model="searchData.contactName" placeholder="请输入" style="width: 100%;" clearable></el-input>
      </el-form-item>
      <el-form-item label="联系人电话" prop="contactMobile">
        <el-input v-model="searchData.contactMobile" placeholder="请输入" style="width: 100%;" clearable></el-input>
      </el-form-item>
      <el-form-item label="是否有待回收旧机" prop="waitRecycleFlag">
        <el-select v-model="searchData.waitRecycleFlag" placeholder="请选择" clearable style="width:100%">
          <el-option v-for="item in waitRecycleOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="可回收总数" prop="canRecycleTotal">
        <div class="range-num">
          <el-input-number v-model="searchData.startWaitCount" placeholder="起始值" style="width:50%;" controls-position="right" :min="0" :max="999999" clearable></el-input-number>
          <span>-</span>
          <el-input-number
            v-model="searchData.endWaitCount"
            placeholder="结束值"
            style="width:50%;"
            controls-position="right"
            :min="endWaitCountMin"
            :max="999999"
            clearable
          ></el-input-number>
        </div>
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <div class="row-bg">
        <el-button type="primary" size="medium" :loading="exportLoadFlag" @click="exportBtnFun">导出</el-button>
        <!-- <el-button type="primary" size="medium" @click="batchRecycleBtnFun">批量回收</el-button> -->
      </div>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table ref="checktableData" :data="tableData" v-loading="tableLoading" :reserve-selection="true" center height="60vh" @selection-change="selectChangeFun">
      <el-table-column type="selection" :selectable="selectableFun" width="55"> </el-table-column>
      <el-table-column label="操作" prop="action" width="160">
        <template slot-scope="scope">
          <el-link v-if="scope.row.waitCount != 0" type="primary" @click="recycleDetFun(scope.row)">待回收明细</el-link>
          <!-- <el-link v-if="scope.row.waitCount != 0" style="margin-left: 12px;" type="primary" @click="rowRecycleFun(scope.row)">回收</el-link> -->
        </template>
      </el-table-column>
      <el-table-column label="仓库名称" prop="stationName" width="140"></el-table-column>
      <el-table-column label="仓库编号" prop="stationId" width="120"></el-table-column>
      <el-table-column label="可回收总数" prop="waitCount" width="120"></el-table-column>
      <el-table-column label="回收中总数" prop="recyclingCount" width="120"></el-table-column>
      <el-table-column label="已回收总数" prop="alreadyCount" width="120"></el-table-column>
      <el-table-column label="丢失数量" prop="lostCount" width="100"></el-table-column>
      <el-table-column label="是否有待回收旧机" prop="recyclingCountFlag" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.waitCount > 0 ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="省" prop="province" width="100"> </el-table-column>
      <el-table-column label="市" prop="city" width="100"> </el-table-column>
      <el-table-column label="区" prop="county" width="100"> </el-table-column>
      <el-table-column label="详细地址" prop="address" width="160"> </el-table-column>
      <el-table-column label="联系人" prop="contactName" width="120"> </el-table-column>
      <el-table-column label="联系电话" prop="contactMobile" width="120"> </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="pagination.page"
        :page-size="pagination.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
      >
      </el-pagination>
    </div>
    <RecycleConfirmDialog ref="recycleConfirmDialogRef" @confirm-recycle="batchRecycleFun"></RecycleConfirmDialog>
    <PlaceOrderDialog ref="placeOrderDialogRef" @opera-success="recycleSuccessFun"></PlaceOrderDialog>
  </div>
</template>
<script>
import RecycleConfirmDialog from './components/RecycleConfirmDialog.vue'
import jdProvinceCity from './mixins/jdProvinceCity.js'
import PlaceOrderDialog from './components/PlaceOrderDialog.vue'
export default {
  components: {
    RecycleConfirmDialog,
    PlaceOrderDialog
  },
  mixins: [jdProvinceCity],
  data() {
    return {
      inventoryItems: [
        { prop: 'waitCount', label: '可回收总数', value: '--', unit: '套' },
        { prop: 'recyclingCount', label: '回收中总数', value: '--', unit: '套' },
        { prop: 'alreadyCount', label: '已回收总数', value: '--', unit: '套' },
        { prop: 'lostCount', label: '丢失数量', value: '--', unit: '套' }
      ],
      waitRecycleOption: [
        {
          label: '是',
          value: '1'
        },
        {
          label: '否',
          value: '0'
        }
      ],
      searchData: {
        stationId: undefined,
        stationName: undefined,
        provinceId: undefined,
        cityId: undefined,
        countyId: undefined,
        contactName: undefined,
        contactMobile: undefined,
        waitRecycleFlag: undefined,
        startWaitCount: undefined,
        endWaitCount: undefined
      },
      tableData: [],
      tableLoading: false,
      pagination: {
        page: 1,
        size: 10
      },
      total: 0,
      selectList: [],
      exportLoadFlag: false
    }
  },
  computed: {
    endWaitCountMin() {
      const startWaitCount = this.searchData.startWaitCount || 0
      let resNum = startWaitCount + 1
      return resNum
    }
  },
  created() {
    this.recycleSuccessFun()
  },
  methods: {
    // 获取统计总数
    getTotalNumFun() {
      const url = `/autoapp-default-server-recovery/api/jd/recycle/station/totalCount`
      return this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          // console.log('===res===', res)
          const { waitCount = '--', recyclingCount = '--', alreadyCount = '--', lostCount = '--' } = res.data || {}
          const newItem = {
            waitCount,
            recyclingCount,
            alreadyCount,
            lostCount
          }
          const newList = JSON.parse(JSON.stringify(this.inventoryItems))
          newList.forEach(item => {
            item.value = newItem[item.prop]
          })
          this.inventoryItems = newList
        }
      })
    },
    // 省改变
    provinceChangeFun() {
      this.searchData.cityId = undefined
      this.searchData.countyId = undefined
      const provinceId = this.searchData.provinceId
      this.getTblCityNew(provinceId)
    },
    // 市改变
    cityChangeFun() {
      this.searchData.countyId = undefined
      const provinceId = this.searchData.provinceId
      const cityId = this.searchData.cityId
      this.getTblCountyNew(provinceId, cityId)
    },
    // 导出
    exportBtnFun() {
      this.exportLoadFlag = true
      setTimeout(() => {
        this.exportLoadFlag = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/jd/recycle/station/export/pageCondition'
      const title = '京东旧机库存列表'
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      // this.global.exportExcel(url, params, title).catch((res) => {
      // 	let blob = new Blob([res.response.data], {
      // 		type: "application/json",
      // 	})
      // 	var blobReader = new Response(blob).json()
      // 	blobReader.then((res) => {
      // 		this.$message.error(res.message)
      // 	})
      // })
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    selectableFun(row) {
      return row.waitCount > 0
    },
    // 选择改变
    selectChangeFun(selection) {
      // console.log('===selection===', selection)
      this.selectList = selection
    },
    // 批量创建回收
    batchRecycleBtnFun() {
      if (this.selectList.length == 0) {
        this.$message.warning('请先选择数据')
        return
      }
      this.$refs.recycleConfirmDialogRef.opendDialog(2)
    },
    // 确认批量回收
    batchRecycleFun() {
      const stationIdList = this.selectList.map(item => item.stationId)
      const params = {
        stationIdList
      }
      const url = `/autoapp-default-server-recovery/api/jd/recycle/saveBatchRecycle`
      return this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          // console.log('===res===', res)
          this.$message.success('批量回收成功')
          this.recycleSuccessFun()
          return
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 回收成功
    recycleSuccessFun() {
      this.getTotalNumFun()
      this.handleSearch()
    },
    // 待回收明细
    recycleDetFun(rowData) {
      // 跳转到京东旧机明细页,仓库编号为对应仓库编号、旧机状态为待回收
      // console.log('===rowData====', rowData)
      const stationId = rowData.stationId
      const toPageParams = {
        oldMachineStatus: '100', // 待回收
        stationId
      }
      this.$router.push({
        path: '/jdOldMachineRecycleManage/jdOldMachineSearch',
        query: {
          ...toPageParams
        }
      })
    },
    // 回收
    rowRecycleFun(rowData) {
      this.$refs.placeOrderDialogRef.opendDialog(rowData)
    },
    // 查询
    handleSearch() {
      this.pagination.page = 1
      this.getList()
    },
    // 清空
    resetForm() {
      this.searchData = {
        stationId: undefined,
        stationName: undefined,
        provinceId: undefined,
        cityId: undefined,
        countyId: undefined,
        contactName: undefined,
        contactMobile: undefined,
        waitRecycleFlag: undefined,
        startWaitCount: undefined,
        endWaitCount: undefined
      }
    },
    // 页码改变
    handleSizeChange(val) {
      this.pagination.page = 1
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    // 获取库存分页
    getList() {
      this.tableLoading = true
      const url = `/autoapp-default-server-recovery/api/jd/recycle/station/pageCondition`
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      return this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          // console.log('===res===', res)
          this.total = res.total || 0
          const resData = res.data || []
          this.tableData = resData
        }
        this.tableLoading = false
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.data-view-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  .item-wrap {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #00b882;
    padding: 10px;
    height: auto;
    color: #fff;

    .unit {
      margin-left: 20px;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      > span {
        font-size: 20px;
        padding-right: 5px;
      }
    }
  }
}
.range-num {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  max-width: 207.42px;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
}
.range-num /deep/.el-input__inner {
  border: none !important;
}
.range-num /deep/.el-input-number__increase,
.range-num /deep/.el-input-number__decrease {
  display: none;
}
.range-num /deep/.el-input-number.is-controls-right .el-input__inner {
  padding-right: 0px !important;
}
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/jdOldMachineInventory.vue